import OpenApiResult from "~/ts/library/openApi/OpenApiResult";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import Random from "~/ts/library/Random";
import {OperatorApplicationEventManager} from "~/operatorApplication/ts/OperatorApplicationEventManager";

export class CopilotCommandRunner {
    static async exec(p: {
        username: string,
        command: OperatorApplicationApi.OperatorCopilotCommandOpenApiModel,
        onResult: (value: string) => void,
        onTimeout?: () => void,
        timeout?: number
    }): Promise<OpenApiResult<any>> {
        let id = Random.uid(32);
        let timeout = p.timeout ?? 15;
        let params: OperatorApplicationApi.OperatorSendCopilotCommandOpenApiModel = {
            id,
            command: p.command,
            username: p.username,
            timeout
        };
        OperatorApplicationEventManager.once(id, p.onResult, timeout * 1000, p.onTimeout);
        return await (new OperatorApiRequest({
            url: "/copilot/sendCommand",
            p: params,
            silent: true
        })).send();
    }
}